const { hasOwnProperty } = Object.prototype;

export default function (JsBase) {
    const DATA = '__jsbase__';
    const components = {};

    JsBase.register = function(name, options) {
        if (!options) {
            if (isPlainObject(components[name])) {
                components[name] = JsBase.extend(components[name]);
            }

            return components[name];
        }

        JsBase[name] = function (element, data) {
            const component = JsBase.register(name);

            // return component.options.functional
            //   ? new component({ data: isPlainObject(element) ? element : [...arguments] })
            //   : element
            //     ? $(element).map(init)[0]
            //     : init();
            return $(element).map(init)[0];

            function init(i, element) {
                const instance = JsBase.get(element, name);

                if (instance) {
                    if (data) {
                        instance.$destroy();
                    } else {
                        return instance;
                    }
                }

                return new component({ el: element, data });
            }
        };

        const opt = isPlainObject(options) ? { ...options } : options.options;
        opt.name = name;
        return (components[name] = isPlainObject(options) ? opt : options);
    }

    JsBase.initAll = function(container) {
        let comps = [];
        for (const name in components) {
            let elements = (container || document).querySelectorAll(`[data-${name}]`);
            elements.forEach(($el) => {
                if (JsBase[name]) {
                    let elComp = JsBase[name]($el);
                    elComp.$el = $el;
                    elComp.$selector = name;
                    JsBase.initComponent(elComp);
                    comps.push(elComp);
                }
            });
        }

        comps.forEach(item => {
            item._callHook('inited');
        });

        let eventOptions = { bubbles: false };
        eventOptions.detail = {components: comps};
        var event = new CustomEvent('jsbase-ready', eventOptions);
        document.dispatchEvent(event);
    }

    JsBase.prototype._initData = function () {
        const { args, el, props = {} } = this.$options;

        for (const key in props) {
            if (el.hasAttribute(`data-${key}`)) {
                this[key] = el.getAttribute(`data-${key}`);
            } else if (typeof props[key] === 'function') {
                this[key] = props[key]();
            } else {
                this[key] = null;
            }
        }

        let attrOptions = el.getAttribute(`data-${this.$options.name}`);
        if (attrOptions.indexOf(':') >= 0) {
            let attrs = attrOptions.split(';') || [];
            for (const attr of attrs) {
                let data = attr.split(':');
                if (data[0].trim()) {
                    let key = data[0].trim();
                    let prop = props[key];
                    if (typeof prop === 'function') {
                        this[key] = prop((data[1] || '').trim(' \''));
                    } else {
                        this[key] = (data[1] || '').trim(' \'');
                    }
                }
            }
        } else if (args) {
            let prop = props[args];
            if (typeof prop === 'function') {
                this[args] = prop(attrOptions.trim(' \''));
            } else {
                this[args] = attrOptions.trim(' \'');
            }
        }
    }

    JsBase.prototype._initMethods = function () {
        const { methods } = this.$options;

        if (methods) {
            for (const key in methods) {
                this[key] = methods[key].bind(this);
            }
        }
    }

    JsBase.prototype._callHook = function (hook) {
        this.$options[hook]?.forEach((handler) => handler.call(this));
    }

    JsBase.prototype._initEvents = function () {
        for (const event of this.$options.events || []) {
            if (hasOwnProperty.call(event, 'handler')) {
                registerEvent(this, event);
            }
        }
    }

    JsBase.prototype._initObservers = function () {
        for (const observer of this.$options.intersections || []) {
            if (hasOwnProperty.call(observer, 'handler')) {
                registerIntersectionObserver(this, observer);
            }
        }
        for (const observer of this.$options.mutations || []) {
            if (hasOwnProperty.call(observer, 'handler')) {
                registerMutationObserver(this, observer);
            }
        }
    }

    JsBase.prototype.dispatchEvent = function (target, eventName, eventDetail, eventOptions) {
        eventOptions = eventOptions || { bubbles: false };
        if (eventDetail) {
            eventOptions.detail = eventDetail;
        }
        var event = new CustomEvent(eventName, eventOptions);
        target.dispatchEvent(event);
    }

    JsBase.extend = function (options) {
        options = options || {};

        const Super = this;
        const Sub = function JsBaseComponent(options) {
            this.$options = mergeOptions(this.constructor.options, options, this);
            const { name } = this.$options;
            this.el = null;
            this.props = {};
            this.data = {};

            this._initData();
            this._initMethods();

            if (!options.el[DATA]) {
                options.el[DATA] = {};
            }
            if (options.el[DATA][name]) {
                return;
            }
            //
            this.el = options.el;
            this._callHook('connect');
            options.el[DATA][name] = this;
        };

        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.options = mergeOptions(Super.options || {}, options);

        Sub.super = Super;
        Sub.extend = Super.extend;

        return Sub;
    };

    JsBase.get = function($el, name) {
        if ($el[DATA] && $el[DATA][name]) {
            return $el[DATA][name];
        } else if ($el[DATA]) {
            var firstKey = Object.keys($el[DATA])[0];
            return $el[DATA][firstKey];
        }
        return null;
    }

    JsBase.initComponent = function(comp) {
        comp._initEvents();
        comp._initObservers();
    }

    function registerEvent(component, event) {
        let {name, handler} = event;
        let target = component.el;
        if (event.selector) {
            target = component.el.querySelectorAll(event.selector);
        } else if (event.target) {
            target = event.target(component);
        } else if (event.el) {
            target = event.el(component);
        }

        if (handler && target) {
            let listener = (e) => {
                handler.call(component, e);
            };
            if (!NodeList.prototype.isPrototypeOf(target)) {
                target.addEventListener(name, listener, false);
            } else {
                target.forEach(t => {
                    t.addEventListener(name, listener, false);
                });
            }
        }
    }

    function registerIntersectionObserver(component, event) {
        let {handler, options} = event;
        var intersectionOptions = {
            root: options.root || document,
            rootMargin: options.rootMargin || '0px',
            threshold: options.threshold || 0.2,
        };
        let target = component.el;
        if (event.selector) {
            target = component.el.querySelector(event.selector);
        } else if (event.el) {
            target = component.el();
        }
        const callback = (entries, observer) => {
            entries.forEach(entry => {
                handler.call(component, entry);
            });
        };
        let observer = new IntersectionObserver(callback, intersectionOptions);
        observer.observe(target);
    }

    function registerMutationObserver(component, event) {
        let {handler, options} = event;
        var mutationOptions = mergeOptions({
            attributes: true,
            childList: true,
            characterData: true,
        }, options);
        let target = component.el;
        if (event.selector) {
            target = component.el.querySelector(event.selector);
        } else if (event.el) {
            target = component.el();
        }

        var observer = new MutationObserver((mutations) => {
            mutations.forEach(function(mutation) {
                handler.call(component, mutation);
            });
        });
        observer.observe(target, mutationOptions);
    }

    function mergeOptions(parent, child, vm) {
        const options = {};

        if (isFunction(child)) {
            child = child.options;
        }

        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }

        if (child.mixins) {
            for (const mixin of child.mixins) {
                parent = mergeOptions(parent, mixin, vm);
            }
        }

        for (const key in parent) {
            mergeKey(key);
        }

        for (const key in child) {
            if (!hasOwn(parent, key)) {
                mergeKey(key);
            }
        }

        function mergeKey(key) {
            options[key] = (strats[key] || defaultStrat)(parent[key], child[key], vm);
        }

        return options;
    }

    let strats = {};
    strats.connect = concatStrat;
    strats.inited = concatStrat;

    const { isArray, from: toArray } = Array;
    const { hasOwnProperty, toString } = Object.prototype;

    function concatStrat(parentVal, childVal) {
        parentVal = parentVal && !isArray(parentVal) ? [parentVal] : parentVal;

        return childVal ?
          parentVal ?
            parentVal.concat(childVal) :
            isArray(childVal) ?
              childVal :
              [childVal] :
          parentVal;
    }

    function hasOwn(obj, key) {
        return hasOwnProperty.call(obj, key);
    }

    function isPlainObject(obj) {
        return toString.call(obj) === '[object Object]';
    }

    function isUndefined(value) {
        return value === void 0;
    }

    function isFunction(obj) {
        return typeof obj === 'function';
    }

    function defaultStrat(parentVal, childVal) {
        return isUndefined(childVal) ? parentVal : childVal;
    }

}
